import React, { useEffect, useState } from "react";
import { Grid, GridColumn, GridToolbar } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";

import { Tooltip, Radio, Button } from "@mui/material";

import {
  setGroupIds,
  setExpandedState,
} from "@progress/kendo-react-data-tools";

import { findMaxDigitsAmongFields } from "../CommonFunction/index";
import { renderNumberFormat } from "../../utils/rendernumber";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import {
  SetGridDataState,
  SetGridFilter,
  SetGridSort,
  setAdditionalWhere,
  setGridPageSize,
  setGridSkip,
} from "../../store/Common/actions";
import { useAuth } from "oidc-react";
import { Btn } from "../../AbstractElements";
import { Icon } from "@progress/kendo-react-common";
import { useLocation } from "react-router-dom";
import { CustomMenu } from "../TelerikDataTable/customMenu";
import ColumnFilter from "./columnFilter";
import {
  BOOLEAN_FIELDS,
  BUTTON_TYPE_FIELDS,
  STATUS_FIELDS,
} from "../TelerikDataTable/Constants";
import { setLetestData } from "../../Components/Create Transaction/slices/ggTrackSlice";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
    take: 10,
    skip: 0,
};
const loadingPanel = (
  <div className="k-loading-mask">
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
  </div>
);
const SQL_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
const ADJUST_PADDING = 4;
const COLUMN_MIN = 4;
const mappings = {
  eq: "{0} = '{1}'",
  neq: "{0} != '{1}'",
  isnull: "{0} IS NULL",
  isnotnull: "{0} IS NOT NULL",
  lt: "{0} < '{1}'",
  lte: "{0} <= '{1}'",
  gt: "{0} > '{1}'",
  gte: "{0} >= '{1}'",
  startswith: "{0} LIKE '{1}%'",
  endswith: "{0} LIKE '%{1}'",
  doesnotstartwith: "{0} NOT LIKE '{1}%'",
  contains: "{0} LIKE '%{1}%'",
  doesnotcontain: "{0} NOT LIKE '%{1}%'",
  isempty: "{0} = ''",
  isnotempty: "{0} != ''",
};
const formatFilter = (mapping, field, value) => {
  return mapping.replace("{0}", field).replace("{1}", value);
};
const formatDateFilter = (mapping, field, value) => {
  return mapping
    .replace("{0}", `CONVERT(DATE,${field})`)
    .replace("'{1}'", `CONVERT(DATE,'${value}')`);
};
const toSQLExpression = (filter) => {
  if (!filter) return;

  let filters = filter.filters,
    field,
    value,
    operator,
    mapping,
    type,
    logic = filter.logic || "AND",
    result = [];

  for (let i = 0; i < filters.length; i++) {
    filter = filters[i];
    field = filter.field;
    value = filter.value;
    operator = filter.operator;

    if (filter.filters) {
      filter = toSQLExpression(filter);
    } else {
      mapping = mappings[operator];
      type = typeof value; ///$.type

      // if (value instanceof Date) {
      //   value =moment(value).format(SQL_DATE_FORMAT) // toString(value.toISOString().slice(0, 19).replace('T', ' '));
      // }
      if (value instanceof Date) {
        filter = formatDateFilter(
          mapping,
          field,
          moment(value).format(SQL_DATE_FORMAT)
        );
      } else {
        filter = formatFilter(mapping, field, value);
      }
    }

    result.push(filter);
  }

  filter = result.join(" " + logic.toUpperCase() + " ");

  if (result.length > 1) {
    filter = "(" + filter + ")";
  }

  return filter;
};
let newData = [];

const TransactionTable = (props) => {
  const {
    filter: storeFilter,
    dataState: storeDataState,
    sort: storeSort,
    skip: storeSkip,
    pageSize: storePageSize,
  } = useSelector((state) => state.CommonReducer);

  const dispatch = useDispatch();
  const URL = useLocation();
  const [group, setGroup] = React.useState(props.group || []);
  const minGridWidth = React.useRef(0);
  const grid = React.useRef(null);
  const [applyMinWidth, setApplyMinWidth] = React.useState(false);
  const [gridCurrent, setGridCurrent] = React.useState(0);

  const [filter, setFilter] = React.useState({ logic: "and", filters: [] });
  const [gridParams, setGridParams] = useState({
    sort: [],
    skip: 0,
    pageSize: 10,
  });

  const [dataState, setDataState] = React.useState(initialDataState);
  let {
    id,
    setSortedColumns,
    selectedColumns,
    pageSize,
    onPageChange,
    onPageSizeChange,
    onFilterChange,
    onSortChange,
    totalCount,
    skip,
    loading,
    sortData,
    actions,
    setChooseFilterMethod,
    searchParams,
    handleClick,
    raiofeild,
    aggregates = [],
    actionsWidth,
    setOpenHistory,
  } = props;
  const [result, setResult] = React.useState({ data: [] });
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const processWithGroups = (data, dataState) => {
    const groups = dataState.group;
    if (groups) {
      groups.map((group) => (group.aggregates = aggregates));
    }
    dataState.group = groups;
    const newDataState = process(data, dataState);
    setGroupIds({
      data: newDataState.data,
      group: dataState.group,
    });
    setResult({ data: newDataState.data });
    return newDataState;
  };
  useEffect(() => {
    if (
      searchParams &&
      searchParams !== null &&
      Object.keys(searchParams).length > 0
    ) {
      setChooseFilterMethod("normalSearch");
    }
  }, [searchParams]);
  const [digitVars, setDigitVars] = useState(null);
  const [collapsedState, setCollapsedState] = React.useState([]);

  const expandChange = (event) => {
    const item = event.dataItem;
    if (item?.groupId) {
      const newCollapsedIds = !event.value
        ? [...collapsedState, item.groupId]
        : collapsedState.filter((groupId) => groupId !== item.groupId);
      setCollapsedState(newCollapsedIds);
    }
  };

  useEffect(() => {
    setGridParams({ pageSize: pageSize, skip: skip, sort: sortData });
  }, [pageSize, skip, sortData]);

  useEffect(() => {
    let gridState = storeDataState[id];
    if (gridState) {
      setDataState(gridState);
    }
  }, [id]);

  useEffect(() => {
    let gridState = storeDataState[id] || { sort: sortData, group: group };
    if (gridState) {
      setDataState(gridState);
    }
  }, [storeDataState, id]);

  useEffect(() => {
    let pageSize = storePageSize[id];
    let skip = storeSkip[id];
    let filter = storeFilter[id];
    let sort = storeSort[id];
    if (filter) {
      setFilter(filter);
    }
    if (pageSize || skip || sort) {
      setGridParams({ pageSize: pageSize, skip: skip, sort: sort });
    }
  }, [storeSort, storePageSize, storeSkip, storeFilter, id]);

  useEffect(() => {
    if (id && storeDataState[id]) {
      setDataState(storeDataState[id]);
    }
  }, [id, storeDataState]);

  useEffect(() => {
    const initialGroupFiled = Array.isArray(storeDataState[id]?.group)
      ? []
      : []; // { field: sortData[0]?.field }
    const allGroupFiled = initialGroupFiled.concat(
      Array.isArray(storeDataState[id]?.group)
        ? storeDataState[id]?.group
        : group
    );
    setGroup(allGroupFiled);
  }, [storeDataState[id]?.group]);

  useEffect(() => {
    let data = {};
    data[id] = dataState;
    dispatch(SetGridDataState(data));
  }, [dataState]);

  useEffect(() => {
    grid.current = document.querySelector(".k-grid");
    window.addEventListener("resize", handleResize);
    props.selectedColumns.map((item) =>
      item.minWidth !== undefined
        ? (minGridWidth.current += item.minWidth)
        : minGridWidth.current
    );
    setGridCurrent(grid.current.offsetWidth);
    setApplyMinWidth(grid.current.offsetWidth < minGridWidth.current);
  }, []);

  const handleResize = () => {
    if (grid.current.offsetWidth < minGridWidth.current && !applyMinWidth) {
      setApplyMinWidth(true);
    } else if (grid.current.offsetWidth > minGridWidth.current) {
      setGridCurrent(grid.current.offsetWidth);
      setApplyMinWidth(false);
    }
  };

  const handleRadioChange = async (e, selectedData) => {
    console.log("Selected Event:", e);
    console.log("Selected Data:", selectedData);
    console.log("Selected ID:", e.target.value);
    setSelectedRow(e.target.value);
    setTimeout(() => {
      setOpenHistory(false);
    }, 100);
    dispatch(setLetestData(selectedData));
  };

  const updateLockColumn = async (col, status) => {
    let copyArray = [...selectedColumns];
    let objectAtIndex = copyArray.findIndex((i) => {
      return i.field === col;
    });
    let copyObject =
      objectAtIndex !== -1 ? { ...copyArray[objectAtIndex] } : {};
    if (copyObject) {
      copyObject["locked"] = status;
      copyArray[objectAtIndex] = copyObject;
      setSortedColumns(copyArray);
    }
  };
  useEffect(() => {
    processWithGroups(
      props.data,
      storeDataState[id] || { sort: sortData, group: group }
    );
  }, [id, props.data]);

  const dataStateChange = (event) => {
    const newDataState = processWithGroups(props.data, event.dataState);
    setResult({ data: newDataState.data });
    setDataState(event.dataState);
  };
  newData = setExpandedState({
    data: result.data,
    collapsedIds: collapsedState,
  });
  useEffect(() => {
    if (props.selectedColumns && props.selectedColumns.length) {
      const newDigitVars = {};

      props.selectedColumns
        .filter((i) => i.show)
        .forEach((i) => {
          const field = i.field;
          if (field !== null && field !== undefined) {
            newDigitVars[field] = findMaxDigitsAmongFields(props.data, [field]);
          }
        });
      setDigitVars(newDigitVars);
    }
  }, [props.selectedColumns, props.data]);
  const DiscontinuedCell = (props) => (
    <td {...props.tdProps}>
      <input
        // disabled={true}
        type="checkbox"
        checked={props.dataItem[props.field || ""]}
      />
    </td>
  );
  return (
    <div>
      {loading && loadingPanel}
      <Grid
        style={{
          maxHeight: "calc(100vh - 420px)",
          minHeight: "450px",
        }}
        data={newData}
        key={props?.id}
        {...dataState}
        reorderable={true}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 20, 50, 100],
          pageSizeValue: gridParams.pageSize,
        }}
        sortable={{
          allowUnsort: true,
          mode: "multiple",
        }}
        groupable={{
          footer: "visible",
        }}
        pageSize={gridParams.pageSize}
        total={totalCount}
        skip={gridParams.skip}
        take={gridParams.pageSize}
        filter={filter}
        lockGroups={true}
        onFilterChange={(props) => {
          setFilter(props.filter);
          const SQLFilter = toSQLExpression(props.filter);
          onFilterChange(SQLFilter);
          if (id) {
            const d = {};
            d[id] = props.filter;
            dispatch(SetGridFilter(d));
            const where = {};
            where[id] = SQLFilter;
            dispatch(setAdditionalWhere(where));
            const skip = {};
            skip[id] = 0;
            dispatch(setGridSkip(skip));
          }
          return false;
        }}
        onSortChange={(props) => {
          if (id) {
            const d = {};
            d[id] = props.sort;
            dispatch(SetGridSort(d));
          }
          setTimeout(() => {
            onSortChange(props.sort);
          }, 500);
        }}
        sort={gridParams.sort}
        onPageChange={(evt) => {
          if (id) {
            const skip = {};
            skip[id] = evt.page.skip;
            dispatch(setGridSkip(skip));
            const d = {};
            d[id] = evt.page.take;
            dispatch(setGridPageSize(d));
          }
          onPageChange(evt);
        }}
        onPageSizeChange={(evt) => {
          if (id) {
            const d = {};
            d[id] = evt.target.value;
            dispatch(setGridPageSize(d));
          }
          onPageSizeChange(evt);
        }}
        filterable={true}
        resizable={true}
        onDataStateChange={dataStateChange}
      >
        {actions && !!actions.length && (
          <GridColumn
            // field="ID"
            key={props?.id}
            title="Actions"
            sortable={false}
            width={
              actionsWidth
                ? raiofeild
                : actionsWidth
                ? "200px"
                : actions?.length <= 3
                ? `${actions?.length * 30 + 70}px`
                : `${actions?.length * 30}px`
            }
            filterable={false}
            // locked={true}
            cell={(props) => {
              // if (props.rowType === "groupHeader") {
              //   return null;
              // }
              // if (props.rowType === "groupFooter") {
              //   return null;
              // }
              return (
                <td
                  key={props?.id}
                  {...props}
                  style={{
                    ...props.style,
                    backgroundColor:
                      props?.dataItem?.IS_DELETED ||
                      props?.dataItem?.IsDeleted === true
                        ? "red"
                        : null, // Used for showing red color in Action Column when delete flag true
                  }}
                >
                  {/* {raiofeild ? ( */}
                  <div key={props?.dataItem?.Id}>
                    <input
                      type="radio"
                      name="selectedItem"
                      id={props?.dataItem?.Id}
                      value={props?.dataItem?.Id}
                      checked={selectedRow == props?.dataItem?.Id}
                      onChange={(e) => handleRadioChange(e, props?.dataItem)}
                    />
                  </div>
                  {/*  ) : ( 
                     <div style={{ display: "flex", columnGap: "6px" }}> 
                        {actions && 
                  //       actions
                  //         .filter(
                  //           (d) =>
                  //             d.onlyVisible === undefined ||
                  //             (d.onlyVisible &&
                  //               props.dataItem[d.onlyVisible] > 0)
                  //         )
                  //         .map((item) =>
                  //           item?.showAsButton ? (
                  //             <Btn
                  //               attrBtn={{
                  //                 color: "primary",
                  //                 onClick: () => {
                  //                   item?.action(props);
                  //                 },
                  //                 disabled: item?.disabled
                                    ? item?.disabled(props)
                  //                   : false,
                  //               }}
                  //             >
                  //               {item?.title}
                  //               <span
                  //                 className={`${
                  //                   ["delete", "Show Details"].includes(
                  //                     item?.title
                  //                   ) && props?.dataItem?.IS_DELETED === true
                                      ? null
                  //                     : item.icon?.iconName
                  //                 } font-primary`}
                  //               ></span>
                  //             </Btn>
                  //           ) : (
                  //             <Tooltip
                  //               style={{ cursor: "pointer" }}
                  //               title={item.title}
                  //               placement="bottom"
                  //             >
                  //               {item?.visible == undefined ||
                  //               (item?.arrayVisible &&
                  //                 item?.arrayVisible.includes(
                  //                   props.dataItem[item?.visible]
                  //                 )) ? (
                  //                 <span
                  //                   style={{ cursor: "pointer" }}
                  //                   onClick={() => {
                  //                     item.action(props);
                  //                   }}
                  //                   className={`${
                  //                     (["delete", "Show Details"].includes(
                  //                       item?.title
                  //                     ) &&
                  //                       props?.dataItem?.IS_DELETED) ||
                  //                     props?.dataItem?.IsDeleted === true
                                        ? null
                  //                       : item.icon?.iconName
                  //                   } font-primary`}
                  //                 ></span>
                  //               ) : (
                  //                 <span></span>
                  //               )}
                  //             </Tooltip>
                  //           )
                  //         )}
                  //   </div>
                  // )}*/}
                </td>
              );
            }}
          />
        )}
        {console.log("props.selectedColumns", props.selectedColumns)}
        {props.selectedColumns && props.selectedColumns.length
          ? props.selectedColumns
              .filter((i) => i.show)
              .map((i, j) => {
                return (
                  <GridColumn
                    headerClassName={i.headerClassName}
                    key={j}
                    className={i.className}
                    field={i.field}
                    filter={i.filter}
                    locked={i.locked || false}
                    title={i.title}
                    width={i.minWidth || i.width}
                    minResizableWidth={100}
                    format={i.format}
                    editor={i.editor}
                    cell={(props) => {
                      const field = props.field || "";
                      const editor = props.editor || "";
                      const format = props.format || "";
                      const value = props.dataItem[field];
                      // console.log("value",props)
                      if (props.rowType === "groupHeader") {
                        return null;
                      }
                      if (props.rowType === "groupFooter") {
                        return null;
                      }
                      return (
                        <td
                          key={i?.title || props?.id}
                          onClick={(e) => {
                            // log("eeeeeeeeeeeeeeeeeeee", e);
                            // setSelectedRow(e.target.value);
                            // handleClick(props);
                          }}
                          style={{
                            ...props.style,
                            whiteSpace: "nowrap",
                            minWidth: i.minWidth || "100px !important",
                            backgroundColor:
                              props?.dataItem?.IS_DELETED ||
                              props?.dataItem?.IsDeleted === true
                                ? "red"
                                : null,
                          }}
                          className={props.className}
                        >
                          {editor === "numeric" &&
                          format != null &&
                          value !== null ? (
                            renderNumberFormat(" ", value, digitVars[field])
                          ) : editor === "date" && value !== null ? (
                            moment(value).format(format)
                          ) : field === "IS_DELETED" ||
                            BOOLEAN_FIELDS.includes(field) ? (
                            value === true ? (
                              "Yes"
                            ) : (
                              "No"
                            )
                          ) : field === "requestType" ? (
                            value?.toUpperCase()
                          ) : (field === "status" ||
                              field === "CurrentWorkflowStatus" ||
                              field === "processStatus" ||
                              BUTTON_TYPE_FIELDS.includes(field)) &&
                            value !== null ? (
                            <Button
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "left",
                                height: "35px",
                              }}
                              color="primary"
                              variant="contained"
                              className="bg-primary text-truncate w-100"
                            >
                              {value ? value : "N/A"}
                            </Button>
                          ) : STATUS_FIELDS.includes(field) ? (
                            value == true || value == "A" || value == 1 ? (
                              "Active".toUpperCase()
                            ) : value == false || value == "I" || value == 0 ? (
                              "Inactive".toUpperCase()
                            ) : (
                              "N/A"
                            )
                          ) : value !== null && value !== "" ? (
                            value
                          ) : (
                            "N/A"
                          )}
                        </td>
                      );
                    }}
                    columnMenu={(props) => (
                      <CustomMenu
                        locked={i.locked}
                        {...props}
                        onColumnLockToggle={(col, status) => {
                          updateLockColumn(col, status);
                        }}
                      />
                    )}
                  />
                );
              })
          : null}
      </Grid>
    </div>
  );
};

export default TransactionTable;
